import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PLANTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PlanType.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PlanType.Code')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('description', 'Entity.PlanType.Description')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
];

export const PLANTYPE_CONFIG = {
  entityName: 'PlanType',
  localizationKey: 'Controlling::Entity.PlanType',
  fields: PLANTYPE_FIELDS,
  permission: 'ControllingStructural.PlanTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
